import { apiUrl, apiKey } from 'utils/config'

/*
 * Api thunks
 */
export const api = {
	getHeaders: () => ({ 'Content-Type': 'application/json',
		'x-api-key': apiKey }),
	_fetch: (uri, { method, body, isFullLink }) => {
		const url = isFullLink ? uri : `${apiUrl}${uri}`
		return fetch(url, {
			method: method,
			headers: isFullLink ? {} : api.getHeaders(),
			body: JSON.stringify(body)
		})
	},
	get: (uri, params) => api._fetch(uri, { ...params, method: 'GET' }),
	put: (uri, params) => api._fetch(uri, { ...params, method: 'PUT' }),
	post: (uri, params) => api._fetch(uri, { ...params, method: 'POST' })
}
